import cx from 'classnames';
import { forwardRef, PropsWithChildren, ReactNode, Ref } from 'react';
import styles from './FormField.module.scss';

interface IProps extends PropsWithChildren {
  label?: ReactNode;
  name?: string;
  error?: ReactNode;
  className?: string;
  classNameLabel?: string;
  description?: ReactNode;
  required?: boolean;
}

const FormField = forwardRef<HTMLDivElement, IProps>(
  (
    {
      label,
      name,
      error,
      children,
      description,
      className,
      classNameLabel,
      required = false,
      ...props
    },
    ref: Ref<HTMLDivElement>
  ) => (
    <div ref={ref} className={cx(className, styles.wrap)} {...props}>
      {label && (
        <label className={cx(classNameLabel, styles.label)} htmlFor={name}>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      )}
      {children}
      {description && <p className={styles.description}>{description}</p>}
      {error && (
        <p data-testid={`${name}-error`} className={styles.errorText}>
          {error}
        </p>
      )}
    </div>
  )
);

FormField.displayName = 'FormField';

export default FormField;
